export default function Page() {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            
        body {
            margin: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 60px 24px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
        }

        section {
            width: 80%;
            font-size: 1rem;
            margin: auto;
        }

        section:first-child h2 {
            text-align: center;
            padding: 30px 0px;
        }

        section .c1 {
            padding: 30px 0 0 0;
        }

        section .c6 {
            font-weight: bold;
            font-size: 1.2rem;
        }

        .highlight {
            font-weight: bold;
        }


        @media (max-width: 850px) {
            section {
                width: 75%;
            }

        }

        @media (max-width: 480px) {
            section {
                width: 90%;
            }

            section .c6 {
                font-size: 1.2rem;
            }
        }

        li.li-bullet-0:before {
            margin-left: -18pt;
            white-space: nowrap;
            display: inline-block;
            min-width: 18pt
        }

        ol {
            margin: 0;
            padding: 0
        }

        table td, table th {
            padding: 0
        }

        .c5 {
            -webkit-text-decoration-skip: none;
            color: #000000;
            font-weight: 700;
            text-decoration: underline;
            vertical-align: baseline;
            text-decoration-skip-ink: none;
            font-size: 11pt;
            font-family: "Arial";
            font-style: normal
        }

        .c12 {
            -webkit-text-decoration-skip: none;
            color: #000000;
            font-weight: 400;
            text-decoration: underline;
            vertical-align: baseline;
            text-decoration-skip-ink: none;
            font-size: 11pt;
            font-family: "Arial";
            font-style: normal
        }

        .c9 {
            color: #000000;
            font-weight: 400;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 26pt;
            font-family: "Arial";
            font-style: normal
        }

        .c13 {
            padding-top: 0pt;
            padding-bottom: 3pt;
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .c0 {
            color: #000000;
            font-weight: 400;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 11pt;
            font-family: "Arial";
            font-style: normal
        }

        .c1 {
            color: #000000;
            font-weight: 400;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 10pt;
            font-family: "Arial";
            font-style: normal
        }

        .c2 {
            padding-top: 0pt;
            padding-bottom: 0pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .c15 {
            text-decoration-skip-ink: none;
            -webkit-text-decoration-skip: none;
            color: #1155cc;
            text-decoration: underline
        }

        .c11 {
            text-decoration-skip-ink: none;
            -webkit-text-decoration-skip: none;
            font-weight: 700;
            text-decoration: underline
        }

        .c10 {
            background-color: #ffffff;
            max-width: 792pt;
            padding: 0pt 0pt 0pt 0pt
        }

        .c3 {
            margin-left: 36pt;
            padding-left: 0pt
        }

        .c8 {
            color: inherit;
            text-decoration: inherit
        }

        .c6 {
            padding: 0;
            margin: 0
        }

        .c14 {
            font-size: 10pt
        }

        .c7 {
            margin-left: 36pt
        }

        .c4 {
            height: 11pt
        }

        .title {
            padding-top: 0pt;
            color: #000000;
            font-size: 26pt;
            padding-bottom: 3pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .subtitle {
            padding-top: 0pt;
            color: #666666;
            font-size: 15pt;
            padding-bottom: 16pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        li {
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }

        p {
            margin: 0;
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
                font-weight: 400;
        }

        h1 {
            padding-top: 20pt;
            color: #000000;
            font-size: 20pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h2 {
            padding-top: 18pt;
            color: #000000;
            font-size: 16pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h3 {
            padding-top: 16pt;
            color: #434343;
            font-size: 14pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h4 {
            padding-top: 14pt;
            color: #666666;
            font-size: 12pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h5 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h6 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            font-style: italic;
            orphans: 2;
            widows: 2;
            text-align: left
        }
    
    `
        }}
      />
      <div className="c5 c8">
        <section>
          <p>
            <strong>TERMS AND CONDITIONS OF USE</strong>{' '}
            <span>
              <br />
              <br />
            </span>
          </p>
          <p>
            <span>ADJ Utility Apps Private Limited (the “</span>
            <strong>Company</strong>
            <span>”) operates a web/mobile application, “</span>
            <strong>KhataBook App</strong>
            <span>” (the “</span>
            <strong>App</strong>
            <span>
              ”) available on Google Play Store, iOS and other similar platforms
              and also operates a website{' '}
            </span>
            <a href="https://khatabook.com/">
              <span>https://khatabook.com/</span>
            </a>
            <span> (the “</span>
            <strong>Website</strong>
            <span>
              ”) . The App and the Website shall be together referred to as the
              “
            </span>
            <strong>Platform</strong>
            <span>”. These terms and conditions (“</span>
            <strong>Terms</strong>
            <span>
              ”) govern the use of or access to the Platform and the Services (
            </span>
            <em>
              <span>as defined below</span>
            </em>
            <span>).&nbsp;</span>
          </p>
          <p>
            <span>
              These Terms constitute a binding and enforceable legal contract
              between the Company and a User (
            </span>
            <em>
              <span>as defined below</span>
            </em>
            <span>) or any end user of the Services (collectively, “</span>
            <strong>you</strong>
            <span>
              ”). You represent and warrant that you (a) have full legal
              capacity and authority to agree and bind yourself to these Terms,
              (b) are 18 (eighteen) years of age or older, and (c) are an Indian
              resident. If you represent an entity, organization, or any other
              legal person, you confirm and represent that you have the
              necessary power and authority to bind such entity, organization,
              or legal person to these Terms.&nbsp;
            </span>
          </p>
          <p>
            <span>
              These Terms also include our privacy policy, available at (“
            </span>
            <a href="https://khatabook.com/privacy.html">
              <span>Privacy</span>
            </a>
            <span> Policy</span>
            <span>
              ”) and any internal guidelines, supplementary terms, policies, or
              disclaimers made available or issued by us from time to time. By
              continuing to access or use the Platform, or any Service on the
              Platform, you signify your acceptance of the Terms. Further, you
              understand that the Platform is intended for the use of Indian
              residents only and by your continuing access and/use of the
              Platform shall be construed as a deemed declaration that you are
              an Indian resident.&nbsp;&nbsp;&nbsp;
            </span>
          </p>
          <p>
            <span>
              The Company reserves the right to make changes to these Terms by
              posting the new/updated version and your continued use and/or
              non-deletion of the Platform shall indicate your agreement to such
              changes. Accordingly, we encourage you to kindly continue to
              review the Terms whenever accessing or using the Platform so as to
              be abreast with the changes that we may be carrying out to these
              Terms.&nbsp;
            </span>
          </p>
          <p>
            <span>
              By using the Services, you agree that you have read, understood,
              and are bound by these Terms, and that you comply with the
              requirements listed herein. If you do not agree to all of these
              Terms or comply with the requirements herein, please do not access
              the Platform or use the Services.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>SERVICES&nbsp;</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <span>
              The Platform (i) provides an online digital ledger book / record
              book wherein the users (“
            </span>
            <strong>Users</strong>
            <span>
              ”), can record their ledger entries with their respective
              customers and (ii) also allows Users to generate a payment link
              which can be sent to their respective customers, and the customers
              could use the payment link and make the payment of the amount to
              the Users in settlement of their obligations towards the Users
              (collectively, “
            </span>
            <strong>Services</strong>
            <span>
              ”). For the purposes of this clause, Services would include any
              other future services the Company provides/proposes to
              provide.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>ON-BOARDING</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                To avail the Services, a User would be required to create a
                profile/sign-up on the Platform (“
              </span>
              <strong>Profile</strong>
              <span>
                ”) using his/her email ID and phone number among other details.
                In addition to setting up username and password to create the
                Profile, the User will be required to furnish certain details,
                including but not limited to phone numbers and details of its
                customers and businesses. The User warrants that all information
                furnished in connection with its Profile is and shall remain
                accurate and true in all respects. The User further agrees and
                undertakes to promptly update its details on the Platform in the
                event of any change or modification of such details.
              </span>
            </li>
            <li>
              <span>
                The User is solely responsible for maintaining the security and
                confidentiality of its username and password and agrees to
                immediately notify the Company in writing at
              </span>
              <em>
                <span> cybercell@khatabook.com </span>
              </em>
              <span>
                of any disclosure or unauthorized use of its Profile or any
                other breach of security with respect to its Profile.
              </span>
            </li>
            <li>
              <span>
                The User expressly agrees to be liable and accountable for all
                activities that take place through its Profile in furtherance of
                the use of Service or otherwise. The Company expressly excludes
                any liability for any unauthorized access to a User&rsquo;s
                Profile.&nbsp;&nbsp;
              </span>
            </li>
            <li>
              <span>
                The User agrees to receive communications from the Company
                regarding: (i) information relating to transactions recorded on
                the Platform; (ii) requests for payment; (iii) information about
                the Company and the Services; (iv) promotional offers and
                services from the Company and its third party partners, and (v)
                any other matter in relation to the Services.&nbsp;
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>KNOW YOUR CUSTOMER POLICY</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                The Company may require Users to upload certain information and
                documents that may be necessary to ascertain their eligibility
                to use certain features of the Services including but not
                limited to their identification documents (“
              </span>
              <strong>KYC Documents</strong>
              <span>”).</span>
            </li>
            <li>
              <span>
                The User hereby authorizes the Company and any third-party
                service provider it may engage with or interact with in
                connection with using the Platform to process KYC Documents and
                ascertain the User&rsquo;s eligibility. Any processing
                undertaken by the Company shall be in accordance with its
                Privacy Policy and these Terms. It is hereby clarified that as
                far as the permission of the KYC Documents by a third-party
                service provider is concerned, the same shall be governed by the
                privacy policy of such third party service provider.&nbsp;
              </span>
            </li>
            <li>
              <span>
                The User agrees that it may be required to submit additional
                documents as and when required by the Company or any of its
                third party service providers and if, in such an event, any
                additional information, data, or documentation is required
                (collectively, “
              </span>
              <strong>Top-Up Documents</strong>
              <span>
                ”), the User hereby agrees to share such Top-Up Documents
                promptly upon request, and further, authorizes the Company to
                process such Top-Up Documents.&nbsp;
              </span>
            </li>
            <li>
              <span>
                The User agrees and warrants to provide valid, true, complete,
                and up-to-date KYC Documents and Top-Up Documents. The User
                further acknowledges that any incorrect or misleading
                information provided shall constitute a material breach of these
                Terms, and the User&rsquo;s access to certain features of the
                Services may be limited or denied in such event.
              </span>
            </li>
            <li>
              <span>
                The list of the KYC Documents and Top-Up Documents may be
                provided to the User at the time of creating the
                Profile/signing-up or at a later stage.&nbsp;
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>TRANSACTION INFORMATION</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                The Users may upload information relating to transactions with
                their customers or relating to their businesses, including the
                sale of goods or services, costs, amounts paid and payable, and
                details of goods and services, on the Platform (such information
                is referred to as “
              </span>
              <strong>Transaction Information</strong>
              <span>
                ”). Transaction Information may be exchanged between the Users
                and their customers through telephonic calls, text message,
                WhatsApp, email, or other electronic mediums that would depend
                on the contact details of Users and their customers provided on
                the Platform.
              </span>
            </li>
            <li>
              <span>
                At the time of creating or uploading the first Transaction
                Information with respect to their customers, the User shall
                inform such customers of its use of the Platform to record such
                Transaction Information and Transaction Information related to
                future transactions and seek such customer&rsquo;s express
                consent in this regard and to:
              </span>
            </li>
          </ol>
          <ol>
            <li>
              <span>
                The creation of a profile of the customer on the Platform, which
                will require sharing such customer&rsquo;s phone number and
                contact details with the Company;
              </span>
            </li>
            <li>
              <span>
                receive communications from the Company regarding: (A)
                information relating to their transactions recorded on the
                Platform; (B) requests for payment; (C) information about the
                Company and the Services; (D) promotional offers and services
                from the Company and its third party partners, and (E) any other
                matter in relation to the Services.&nbsp;
              </span>
            </li>
          </ol>
          <ol>
            <li>
              <span>
                If such customers fail to provide consent, or withdraw consent,
                the User shall immediately cease to use the Services in relation
                to such customers.&nbsp;
              </span>
            </li>
            <li>
              <span>
                The User shall be solely responsible for obtaining such consent
                from its customers and the Company shall assume that such
                consent as required under clause 4(b) above is sought and
                received by the User if the User provides&nbsp; details of such
                Transaction Information relating to any of such customers at any
                time during the use of the Platform.
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>THIRD PARTY SERVICES</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                The Services may include services, content, documents, and
                information owned by, licensed to, or otherwise made available
                by a third party (“
              </span>
              <strong>Third Party Services</strong>
              <span>
                ”) or contain links to Third Party Services. Users understand
                that Third Party Services are the responsibility of the third
                party that created or provided it and acknowledge that use of
                such Third-Party Services is solely at their own risk.
              </span>
            </li>
            <li>
              <span>
                The Company makes no representations and hereby expressly
                excludes all warranties and liabilities arising out of or
                pertaining to such Third-Party Services, including their
                accuracy or completeness. Further, all intellectual property
                rights in and to Third Party Services are the property of the
                respective third parties.
              </span>
            </li>
            <li>
              <span>
                The Company enables payments via payment service providers (“
              </span>
              <strong>PSP</strong>
              <span>
                ”) partners and the User should take care not to share his
                personal UPI pin or OTP with any third party intentionally or
                unintentionally. The Company never solicits information such as
                UPI pin or OTP over a call or otherwise. The Company shall not
                be liable for any fraud due to the sharing of such details by
                the User. The providers providing Third Party Services / PSP
                partners shall not be liable for any fraud due to sharing of
                such details by the User. If any of such
                fraudulent&nbsp;transactions occur and where the User
              </span>{' '}
              <span>
                shares his debit/credit card or UPI information, the Company may
                share relevant information of such transaction if the
                victim&nbsp;approaches the Company via proper channels including
                customer support number and cybercell@khatabook.com
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>USER RESPONSIBILITIES</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                The User hereby represents and warrants that all information
                that is provided by the User through or in relation to the
                Services is valid, complete, true, and correct on the date of
                agreeing to these Terms and shall continue to be valid,
                complete, true, and correct throughout the duration of the
                User&rsquo;s use of the Platform. The Company does not accept
                any responsibility or liability for any loss or damage the User
                may suffer or incur if any information, documentation, material,
                or data provided to avail the Services is incorrect, incomplete,
                inaccurate, or misleading, or if the User fails to disclose any
                material fact.
              </span>
            </li>
            <li>
              <span>
                The User shall be solely responsible for ensuring compliance
                with applicable laws and shall be solely liable for any
                liability that may arise due to a breach of its obligations in
                this regard.
              </span>
            </li>
            <li>
              <span>
                The User shall extend all cooperation to the Company in its
                defending of any proceedings that may be initiated against it
                due to a breach of the User&rsquo;s obligations or covenants
                under these Terms.&nbsp;
              </span>
            </li>
            <li>
              <span>
                While the Company uses commercially reasonable efforts to
                provide Users with a daily backup of their Transaction
                Information, Users should regularly and independently save,
                backup, and archive such Transaction Information.&nbsp;
              </span>
            </li>
            <li>
              <span>
                The User shall not use the Services in any manner except as
                expressly permitted in these Terms. Without limiting the
                generality of the preceding sentence, the User may not:
              </span>
            </li>
          </ol>
          <ol>
            <ol>
              <ol>
                <li>
                  <span>
                    Infringe either directly or indirectly any third-party
                    proprietary rights, including but not limited to copyrights,
                    patents, trademarks, or trade secrets, of any party;
                  </span>
                </li>
                <li>
                  <span>
                    except as may be provided hereunder, use in any manner
                    including copying, displaying, distributing, modifying,
                    publishing, reproducing, storing, transmitting, posting,
                    translating, creating any derivative works from, or license
                    the Services;
                  </span>
                </li>
                <li>
                  <span>
                    use the Services to transmit any data or send or upload any
                    material that contains viruses, trojan horses or any other
                    harmful programmes or similar computer code designed to
                    adversely affect the operation of any computer software or
                    hardware;
                  </span>
                </li>
                <li>
                  <span>
                    use any robot, spider,&nbsp;other automated device, or
                    manual process to monitor or copy the Platform or Services
                    or any portion thereof;
                  </span>
                </li>
                <li>
                  <span>
                    use the Services in furtherance of / to engage in any
                    activity which may be grossly harmful, harassing,
                    blasphemous, defamatory, obscene, pornographic, pedophilic,
                    libelous, invasive of another&apos;s privacy, hateful, or
                    racially, ethnically objectionable, disparaging, relating or
                    encouraging money laundering or gambling, or otherwise
                    unlawful in any manner whatever; or unlawfully threatening
                    or unlawfully harassing including but not limited to
                    &quot;indecent representation of women&quot; within the
                    meaning of the Indecent Representation of Women
                    (Prohibition) Act, 1986;&nbsp;
                  </span>
                </li>
                <li>
                  <span>
                    engage in the systematic retrieval of content from the
                    Platform or Services to create or compile, directly or
                    indirectly, a collection, compilation, database or
                    directory; or
                  </span>
                </li>
                <li>
                  <span>violate applicable laws in any manner.</span>
                </li>
              </ol>
            </ol>
          </ol>
          <ol>
            <li>
              <span>
                Users who are expected to conduct proper research to ensure that
                the goods and services they send payment links for are in
                compliance with all applicable laws and we encourage users to
                cross-check before generating payment link for prohibited
                content may result in the suspension or removal of user&rsquo;s
                account.
              </span>
            </li>
            <li>
              <span>
                The User shall not use the Services for / in furtherance of any
                sale or supply of prohibited products or services including but
                not limited to:
              </span>
            </li>
          </ol>
          <ol>
            <ol>
              <ol>
                <li>
                  <span>sale of regulated goods;</span>
                </li>
                <li>
                  <span>
                    sale of counterfeit, replicas and pirated goods and goods
                    infringing any intellectual property rights including
                    pirated recordings or copies of unauthorized copyrighted
                    materials whether in electronic or physical form or any
                    other medium which may not be in existence at present;
                  </span>
                </li>
                <li>
                  <span>
                    sale of tobacco and cigarettes which includes cigarettes,
                    cigars, chewing tobacco, and related products;
                  </span>
                </li>
                <li>
                  <span>
                    sale of liquor or any narcotic drugs and psychotropic
                    substances;
                  </span>
                </li>
                <li>
                  <span>
                    sale / supply of any good or service which may not be in
                    public interest;
                  </span>
                </li>
                <li>
                  <span>gambling or other prohibited activities; and</span>
                </li>
                <li>
                  <span>
                    sale / supply of good or service which results in
                    non-compliance of any applicable law.
                  </span>
                </li>
              </ol>
            </ol>
          </ol>
          <ol>
            <li>
              <span>
                The User shall be solely responsible for compliance with all the
                applicable laws including without limitation the Prevention of
                Money Laundering Act, 2002 and the rules made thereunder. The
                Company shall not be responsible for any claims or liability or
                losses that may arise due to non-compliance of the anti-money
                laundering laws in India.
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>INTELLECTUAL PROPERTY</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                All rights, title, and interest in and to the Platform and
                Services, including all intellectual property rights arising out
                of the Platform and Services, are owned by or otherwise lawfully
                licensed by the Company. Subject to compliance with these Terms,
                the Company grants the User a non-exclusive, non-transferable,
                non-sub licensable, royalty-free, revocable, and limited licence
                to use the Platform and Services in accordance with these Terms
                and its written instructions issued from time to time.
              </span>
            </li>
            <li>
              <span>
                The User should assume that everything the User sees or reads on
                the Platform is protected under the Indian Copyright Act, 1957
                and other intellectual property laws of India and may not be
                used except with the prior written permission of the Company.
              </span>
            </li>
            <li>
              <span>
                The Company may freely use, copy, disclose, publish, display,
                distribute without any payment of royalty, acknowledgement,
                prior consent, or any other form of restriction arising out of
                the User&rsquo;s intellectual property rights.&nbsp;
              </span>
            </li>
            <li>
              <span>
                Except as stated in these Terms, nothing in these Terms should
                be construed as conferring any right in or license to the
                Company&rsquo;s or any third party&rsquo;s intellectual rights.
              </span>
            </li>
            <li>
              <span>
                The contents of this Platform, including but not limited to the
                text and images herein and their arrangements, unless otherwise
                noted, are copyright-protected in the whole and every part of
                this Platform and the same belongs to the Company and may not be
                used, sold, licensed, copied or reproduced in whole or in part
                in any manner or form or in or on any media to any person
                without the prior written consent of the Company.
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>TERM AND TERMINATION</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                These Terms shall remain in effect unless terminated in
                accordance with the terms hereunder.
              </span>
            </li>
            <li>
              <span>
                The Company may terminate a User&rsquo;s access to or use of the
                Services, or any portion thereof, immediately and at any point,
                at its sole discretion, if the User violates or breaches any of
                its obligations, responsibilities, or covenants under these
                Terms.&nbsp;
              </span>
            </li>
            <li>
              <span>
                Upon termination these Terms shall terminate, except for those
                clauses that expressly or are intended to survive termination or
                expiry.
              </span>
            </li>
            <li>
              <span>
                Notwithstanding anything to the contrary contained in the Terms,
                upon termination of a User&rsquo;s access to or use of the
                Services, all amounts or outstanding monies due by you in
                relation to your use of or access to the Services shall become
                immediately payable.
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>DISCLAIMERS AND WARRANTIES</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>The use of the Services is at your sole risk.</span>
            </li>
            <li>
              <span>
                You acknowledge and agree that the Company is not engaged in the
                provision, grant, or disbursement of any financial product. The
                Company is not and will not be responsible for any claim or for
                any damages suffered, whether by the Users, the customers of the
                Users or any other person or party, that are related, directly
                or indirectly, to or arise out of the same including any
                payments made by the User or by the customers of the User using
                the payment link generated using the Platform. The User further
                agrees and undertakes to retain proof of sale documentation (in
                electronic or physical form) in connection with each payment
                link it generates or sends to customers.
              </span>
            </li>
            <li>
              <span>
                To the extent permitted by applicable law, the Services are
                provided on an “as is” and “as available” basis. The Company
                does not warrant that operation of the Services will be
                uninterrupted or error free or that the functions contained in
                the Services will meet your requirements.
              </span>
            </li>
            <li>
              <span>
                To the fullest extent permissible under applicable law, the
                Company expressly disclaims all warranties of any kind, express
                or implied, arising out of the Services, including warranties of
                merchantability, fitness for a particular purpose, satisfactory
                quality, accuracy, title and non-infringement, compatibility,
                applicability, usability, appropriateness, and any warranty that
                may arise out of course of performance, course of dealing, or
                usage of trade.
              </span>
            </li>
            <li>
              <span>
                You hereby accept full responsibility for any consequences that
                may arise from your use of the Services, and expressly agree and
                acknowledge that the Company shall have absolutely no liability
                with respect to the same.
              </span>
            </li>
            <li>
              <span>
                To the fullest extent permissible by law, the Company, its
                affiliates, and its related parties each disclaim all liability
                to you for any loss or damage arising out of or due to:&nbsp;
              </span>
            </li>
          </ol>
          <ol>
            <ol>
              <ol>
                <li>
                  <span>
                    your use of, inability to use, or availability or
                    unavailability of the Services, including any Third Party
                    Services;
                  </span>
                </li>
                <li>
                  <span>
                    the occurrence or existence of any defect, interruption, or
                    delays in the operation or transmission of information to,
                    from, or through the Services, communications failure,
                    theft, destruction or unauthorized access to the
                    Company&rsquo;s records, programmes, services, server, or
                    other infrastructure relating to the Services; or
                  </span>
                </li>
                <li>
                  <span>
                    the failure of the Services to remain operational for any
                    period of time.
                  </span>
                </li>
              </ol>
            </ol>
          </ol>
          <ol>
            <li>
              <span>
                Notwithstanding anything to the contrary contained herein,
                neither the Company nor any of its affiliates or related parties
                shall have any liability to you or any third party for any
                indirect, incidental, special or consequential damages or any
                loss of revenue or profits arising under, directly or
                indirectly, or relating, in any manner whatsoever, to these
                Terms or the Services. To the maximum extent permitted by law,
                you agree to waive, release, discharge, and hold harmless the
                Company, its affiliated and subsidiary companies, its parent
                companies, and each of their directors, officers, employees, and
                agents, from any and all claims, losses, damages, liabilities,
                expenses and causes of action arising out of the Services.
              </span>
            </li>
            <li>
              <span>
                Khatabook currently is not a payment aggregator or payment
                gateway-it is enabling payments for its users via third-party
                payments service providers. Any charges levied by Khatabook for
                usage are service charges. In case you need an invoice for the
                charges levied please email to support@khatabook.com
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>INDEMNITY</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <span>
              You shall indemnify, defend at the Company&rsquo;s option, and
              hold the Company, its parent companies, subsidiaries, affiliates,
              and their officers, associates successors, assigns, licensors,
              employees, directors, agents, and representatives, harmless from
              and against any claim, demand, lawsuits, judicial proceeding,
              losses, liabilities, damages and costs (including, without
              limitation, from all damages, liabilities, settlements, costs and
              attorneys&rsquo; fees) due to or arising out of your access to the
              Services, use of the Services, violation of these Terms or any
              infringement by any third party who may use your account with the
              Company, of these Terms.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>CONSENT TO USE DATA</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                You agree that the Company and any third-party service providers
                it engages, may, in accordance with its Privacy Policy, collect
                and use your information and technical data and related
                information.
              </span>
            </li>
            <li>
              <span>
                The Company may use information and data pertaining to your use
                of the Services for analytics, trends&rsquo; identification, and
                purposes of statistics to further enhance the effectiveness and
                efficiency of the Platform.
              </span>
            </li>
            <li>
              <span>
                Subject to applicable laws, the Company may be directed by law
                enforcement agencies or the government and related bodies to
                disclose data in relation to Users in connection with criminal
                proceedings. You understand and agree that in such instances,
                the Company shall have the right to share such data with
                relevant agencies or bodies.
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>MAINTENANCE OF RECORDS</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <span>
              You shall maintain the records of all payment transactions on the
              Platform independently of the Platform (by way physical copies et
              cetera) and the Company reserves the right to seek copies of such
              records for their own use including record keeping.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>FEES/CHARGES</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <span>
              The Company reserves the right to charge convenience fee for the
              Services and non-payment may result in denial of Services.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>MODIFICATION</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <span>
              The Company reserves the right at any time to add, modify or
              discontinue, temporarily or permanently, the Services (or any part
              thereof) with or without cause. The Company shall not be liable
              for any such addition, modification, suspension or discontinuation
              of the Services.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>
                  JURISDICTION, GOVERNING LAWS, AND DISPUTE RESOLUTION
                </strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <span>
              These Terms shall be governed by and construed and enforced in
              accordance with the laws of India. Subject to other provisions in
              this Clause, courts in Bangalore shall have exclusive jurisdiction
              over all issues arising out of these Terms or the use of the
              Services.&nbsp;
            </span>
          </p>
          <p>
            <span>
              Any controversies, conflicts, disputes, or differences arising out
              of these Terms shall be resolved by arbitration in Bangalore in
              accordance with the Arbitration and Conciliation Act, 1996 for the
              time being in force, which is deemed to be incorporated by
              reference in this Clause. The tribunal shall consist of 1 (one)
              arbitrator appointed by the Company. The language of the
              arbitration shall be English.&nbsp;
            </span>
          </p>
          <p>
            <span>
              The parties to the arbitration shall keep the arbitration
              confidential and not disclose to any person, other than on a need
              to basis or to legal advisors, unless required to do so by law.
              The decision of the arbitrator shall be final and binding on all
              the Parties hereto.
            </span>
          </p>
          <p>
            <span>
              Each party to the arbitration shall bear its own costs with
              respect to any dispute.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>MISCELLANEOUS PROVISIONS</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <ol>
              <li>
                <span>
                  Modification – The Company reserves the right at any time to
                  modify these Terms and to add new or additional terms or
                  conditions on use of the Services. Such modifications and
                  additional terms and conditions will be communicated to you
                  and, unless expressly rejected (in which these Terms shall
                  terminate), will be effective immediately and will be
                  incorporated into these Terms. In the event you refuse to
                  accept such changes, these Terms will terminate.
                </span>
              </li>
              <li>
                <span>
                  Severability - If any provision of these Terms is determined
                  by any court or other competent authority to be unlawful or
                  unenforceable, the other provisions of these Terms will
                  continue in effect. If any unlawful or unenforceable provision
                  would be lawful or enforceable if part of it were deleted,
                  that part will be deemed to be deleted, and the rest of the
                  provision will continue in effect (unless that would
                  contradict the clear intention of the clause, in which case
                  the entirety of the relevant provision will be deemed to be
                  deleted).
                </span>
              </li>
              <li>
                <span>
                  Assignment - You shall not license, sell, transfer or assign
                  your rights, obligations, or covenants under these Terms in
                  any manner without the Company&rsquo;s prior written consent.
                  The Company may grant or withhold this consent in its sole
                  discretion and subject to any conditions it deems appropriate.
                  The Company may assign its rights to any of its affiliates,
                  subsidiaries, or parent companies, or to any successor in
                  interest of any business associated with the Services without
                  any prior notice to you.&nbsp;
                </span>
              </li>
              <li>
                <span>
                  Notices - All notices, requests, demands, and determinations
                  for the Company under these Terms (other than routine
                  operational communications) shall be sent
                  to&nbsp;feedback@khatabook.com
                </span>
              </li>
              <li>
                <span>
                  Third Party Rights - No third party shall have any rights to
                  enforce any terms contained herein.
                </span>
              </li>
              <li>
                <span>
                  Translations –The Company may provide you with translated
                  versions of these Terms solely to assist you with
                  understanding these Terms in greater detail. The English
                  version of these Terms shall be controlling in all respects.
                  In the event of any inconsistency between the English version
                  of these Terms and any translated version, the terms of the
                  English version shall prevail.&nbsp;
                </span>
              </li>
            </ol>
          </ol>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>
                <strong>REFUND/CANCELLATION</strong>
              </strong>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            <span>Cancellation</span>
          </p>
          <ol>
            <ol>
              <li>
                <span>
                  UPI Transactions cannot be cancelled after initiating the
                  transaction. If the User has entered the wrong number/VPA ID,
                  then the Company is not a liable party in the transaction.
                </span>
              </li>
              <li>
                <span>
                  All UPI transactions are real-time and if there is any delay
                  in the end of the transaction then the User can check with
                  support team of Khatabook at{' '}
                </span>
                <a href="mailto:feedback@khatabook.com">
                  <em>
                    <span>feedback@khatabook.com</span>
                  </em>
                </a>
                <span> after 30 mins cool period.</span>
              </li>
            </ol>
          </ol>
          <p>
            <span>Debit/Credit Card</span>
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <em>
                <span>
                  If the User has any issues related to transactions linked with
                  Debit/Credit card, then the User must report the same to the
                  Company&rsquo;s call center
                </span>
                <em>
                  <span> 9606-800-800 </span>
                </em>
                <span>or Via mail feedback@khatabook.com</span>
              </em>
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            <ol>
              <li>
                <span>
                  The Company will respond and try to resolve the issue in the
                  given escalation matrix as per the Company&rsquo;s internal
                  processes and policies.
                </span>
              </li>
              <li>
                <span>
                  All refunds will be processed by following the validation of
                  the transaction from case to case basis in the given legal
                  framework.
                </span>
              </li>
              <li>
                <span>
                  Escalation matrix remains the same for the
                  Refunds/Cancellation for all the transactions.
                </span>
              </li>
              <li>
                <span>
                  The Company allows the Users to export the PDF from its
                  account which the User can share with its customer as a
                  statement/reminder for collections.
                </span>
              </li>
            </ol>
          </ol>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>

          <p>
            <strong>KB Coins T&amp;C</strong>{' '}
            <span>
              <br />
              <br />
            </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c0">
              This document is an electronic record in terms of Information
              Technology Act, 2000, amendments thereof from time to time and the
              rules thereunder as applicable and the amended provisions
              pertaining to electronic records in various statutes as amended by
              the Information Technology Act, 2000. This electronic record is
              generated by a computer system and does not require any physical
              or digital signatures.
            </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c0">
              Please read the terms and conditions carefully before registering,
              accessing, or using the KB Coins, herein referred as &quot;KB
              Coins&quot;. These terms and conditions, (herein referred as “KB
              Coins T&amp;Cs”) are a legal contract (&quot;Agreement&quot;)
              between You and ADJ Utility Apps Private Limited (“Khatabook”)
              having its registered office at 1539, 18th Cross Road, Sector 3,
              HSR Layout, Bengaluru - 560102 &nbsp;and its corporate office at
              1539, 18th Cross Rd, Sector 3, HSR Layout, Bengaluru, Karnataka
              560102.{' '}
            </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c0">
              You agree and acknowledge that you have read the terms and
              conditions set forth below. If you do not agree to these terms and
              conditions or do not wish to be bound by these terms and
              conditions, you may not use the Services and/or immediately
              terminate the Services.
            </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c0">
              We may amend the terms and conditions at any time by posting an
              updated version at Khatabook website(s) and Khatabook Business
              App(s). The updated version of the Terms of Service shall take
              effect immediately upon posting. It is Your responsibility to
              review these Terms of Use periodically for updates / changes or
              while using KB Coins. Your continued use of Khatabook Coins
              following the posting of changes will mean that You accept and
              agree to the revisions including additional Terms or removal of
              portions of these Terms, modifications etc. As long as You comply
              with these Terms of Use, We grant You a personal, non-exclusive,
              non-transferable, limited privilege to enter and avail the
              Services.
            </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c5">Welcome to the Khatabook Coins! </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <ul className="c6 lst-kix_1cigejg61btd-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                At Khatabook, we&rsquo;re building utility solutions for the
                nation&rsquo;s 6.3 crore-strong MSME sector in India.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Khatabook&rsquo;s goal can be summed up simply - Empowering
                merchants by simplifying their business.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                KB Coins feature is integral part of Khatabook App and Platform.
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c5">Eligibility</span>
          </p>
          <p className="c2 c4">
            <span className="c5"></span>
          </p>
          <ul className="c6 lst-kix_9uyymkdv76vs-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                By registering with Khatabook and accessing the KB Coin
                Services, you are representing the following:
              </span>
            </li>
          </ul>
          <p className="c2 c7">
            <span className="c0">a. You are 18 years of age or older;</span>
          </p>
          <p className="c2 c7">
            <span className="c0">
              b. You are capable of entering into a legally binding agreement;
              and
            </span>
          </p>
          <p className="c2 c7">
            <span className="c0">
              c. You are not barred or otherwise legally prohibited from
              accessing or using the Khatabook App and KB Coin Services.
            </span>
          </p>
          <ul className="c6 lst-kix_nk0qyjh97qlu-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                If you allow anyone to use your account, including individuals
                under 18 years of age, you will still be responsible for
                ensuring that such individuals comply with these Terms of Use.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                You will be responsible for all actions these individuals take
                in and/or through your account.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                You also acknowledge that Khatabook does not have the
                responsibility of ensuring that You meet the aforesaid
                eligibility requirements.
              </span>
            </li>
          </ul>
          <ul className="c6 lst-kix_13x3qcm4xq8z-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Please read the terms and conditions carefully before
                registering, accessing or using the Khatabook Coin Services
                (defined below) offered through the Khatabook website, Khatabook
                App (defined below) or through applications or websites of
                Khatabook Business Apps (defined below).{' '}
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c5">KB Coins Introduction</span>
          </p>
          <p className="c2 c4">
            <span className="c5"></span>
          </p>
          <ul className="c6 lst-kix_tnjbnf4mlory-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                These terms and conditions regulate the use of KB Coins in a
                closed loop account issued by the company to a consumer for
                buying goods and services exclusively from that company.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                These instruments do not permit cash Loading, withdrawal or
                redemption and it&rsquo;s not offering any kind of wallet
                system.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Services which may be added from time to time under the brand
                name “KB Coins” offered by Khatabook.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                By proceeding to use the KB Coins, you (“User”/ “you”/ “your”)
                signify your consent to be bound by these “KB Coins T&amp;Cs” in
                addition to agreeing to the General Khatabook Terms and
                Conditions(“General ToU”) and Khatabook “Privacy Policy”. By use
                of KB Coins, you shall be contracting with Khatabook and these
                KB Coins T&amp;Cs referenced herein will constitute Your binding
                obligations with Khatabook.
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c5">Buying KB Coins &amp; Refunds</span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <ul className="c6 lst-kix_4cfswtn9kaxs-0 start">
            <li className="c2 c3 li-bullet-0">
              <span>
                In order to buy KB Coins on Khatabook, You are required to place
                an order or transact on the Platform, for a minimum of{' '}
              </span>
              <span>Rs.19 and max of Rs 5000</span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                All KB Coins earnings will be at the order level and not at the
                item level
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                KB Coins would be non-transferable between subscriptions.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span>KB Coins can&apos;t be used for any</span>
              <span>&nbsp;3rd party transactions</span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Each plan purchased will come with its own expiry date which
                would be 12 months from the date of purchase.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                KB Coins will be issued for the free of cost for the selected
                users with defined rules and regulations where their usage,
                crediting, and that they will have a shorter expiry period(12
                months) as compared to paid coins.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                No refund of money post-purchase : While will eventually support
                refunds in case of customer escalations on the support side(at
                their discretion) but there will be no provision where a user
                can directly raise a refund request from the app.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Conversion rate(Coin: INR), and the cost of coin/SMS, WhatsApp,
                IVR Call, and email are subject to change as and when deemed fit
                by Khatabook
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Invoice would be issued from Khatabook to the user for every
                purchase against the selected users/company.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Once issued, invoices cannot be edited for any details like GST
                ID/address, etc
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c11">
              Indemnification &amp; Limitation of Liability
            </span>
            <span className="c0">&nbsp;</span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <ul className="c6 lst-kix_wt004irtmqfa-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                You shall indemnify and hold harmless Khatabook, Khatabook
                Coins, its owner, licensee, affiliates, subsidiaries, group
                companies (as applicable) and their respective officers,
                directors, agents, and employees, from any claim or demand, or
                actions including reasonable attorneys&apos; fees, made by any
                third party or penalty imposed due to or arising out of Your
                breach of this Terms of Use, privacy Policy and other Policies,
                or Your violation of any law, rules or regulations or the rights
                (including infringement of intellectual property rights) of a
                third party.
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <ul className="c6 lst-kix_iceatypaf6m5-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Financial and non-financial transactions performed by You on
                Khatabook Platform is always processed by You or under Your
                exclusive authorization.
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                In no event will Khatabook be liable for any indirect,
                consequential, incidental, special or punitive damages,
                including without limitation damages for loss of profits or
                revenues, business interruption, loss of business opportunities,
                loss of data or loss of other economic interests, whether in
                contract, negligence, tort or otherwise, arising from the use of
                or inability to use the Services, however caused and whether
                arising in contract, tort, negligence, warranty or otherwise,
                exceed the amount paid by You for using the Services giving rise
                to the cause of action or Rupees One Hundred (Rs. 100) whichever
                is less.
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <p className="c2">
            <span className="c5">Communication </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <ul className="c6 lst-kix_50bi00culgqx-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                Khatabook and Khatabook Apps entities may communicate with you
                on the contact information that you may have provided to Us
                during the course of your engagement, including but not limited
                to signup, transacting or availing any third party products or
                services on Khatabook Platform.{' '}
              </span>
            </li>
          </ul>
          <ul className="c6 lst-kix_9o3lqjnunmuw-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                We will send you communication alerts via emails or SMS or push
                notifications or via other progressive technology.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                You also agree that there can be disruption in communications
                due to factors that are not under Our control, including but not
                limited to Your Phone being switched off, incorrect email
                address, network interruptions.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                You agree not to hold Khatabook liable for non-delivery for any
                alert or any loss suffered by you due to delay, distortion or
                failure of communication.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                You further acknowledge that you are responsible for the contact
                details shared with Us and shall update us on any change on your
                contact details.{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c0">
                You authorize Us to contact you and communicate with you for any
                Khatabook Service or Offer(s).{' '}
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span>
                We may use third party service providers to send alerts or
                communicate with you. You authorize Khatabook and Khatabook
                Entities to override the DND settings to reach out to you over
                calls, SMS, emails and any other mode of communication.
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c12"></span>
          </p>
          <p className="c2">
            <span className="c5">Grievance Redressal </span>
          </p>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
          <ul className="c6 lst-kix_5fkitbljef2r-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c1">
                We are responsible for facilitating grievances / complaints
                resolution of the customers on-boarded on our application.{' '}
              </span>
            </li>
          </ul>
          <ul className="c6 lst-kix_qke19xbtpqyd-0 start">
            <li className="c2 c3 li-bullet-0">
              <span className="c14">
                You may avail of customer support by following the steps set out
                here -{' '}
              </span>
              <span className="c14 c15">
                <a
                  className="c8"
                  href="https://www.google.com/url?q=https://khatabook.com/contact-us/&amp;sa=D&amp;source=editors&amp;ust=1677690353132637&amp;usg=AOvVaw1NvnIHx_LjhQ2QiIKmBkyY"
                >
                  https://khatabook.com/contact-us/
                </a>
              </span>
            </li>
            <li className="c2 c3 li-bullet-0">
              <span className="c1">
                If Your issue is not addressed, you may also reach out by email
                to grievanceofficer@khatabook.com
              </span>
            </li>
          </ul>
          <p className="c2 c4">
            <span className="c0"></span>
          </p>
        </section>
      </div>
    </>
  );
}
